import { createSlice } from "@reduxjs/toolkit";
import { AppState } from "./models/appState";
import * as reducers from "./appReducers";

export const initialState: AppState = {
  modals: [],
  isLoaded: false,
  appContext: {
    language: "sv",
    numberFormat: "sv-SE",
    dateFormat: "sv-SE",
  },
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    load: reducers.load,
    loadAppContext: reducers.loadAppContext,
    showConfirmDialog: reducers.showConfirmDialog,
    closeModal: reducers.closeModal,
    showSlideout: reducers.showSlideout,
  },
});

export const { load, loadAppContext, showConfirmDialog, closeModal, showSlideout } = appSlice.actions;

export default appSlice.reducer;
